import styled from '@emotion/styled'
import { baseLayout } from '../../constants/theme'

const Main = styled('div')(({ theme, collapsed, locale }) => ({
  position: 'relative',
  zIndex: '1',
  backgroundColor: theme.mainContentBg,
  paddingTop: baseLayout.headerHeight,
  marginLeft: collapsed
    ? baseLayout.sidebarCollapsedWidth
    : baseLayout.sidebarWidth,
  marginRight: 'auto',
  overflow: 'hidden',
  minHeight: `calc(100vh - ${baseLayout.footerHeight})`,
  transition: 'margin-left 0.3s ease-in-out',
  '@media (max-width: 992px)': {
    marginLeft: collapsed ? '0 !important' : baseLayout.sidebarCollapsedWidth,
  },
  ...(locale === 'ar' && {
    marginRight: collapsed
      ? baseLayout.sidebarCollapsedWidth
      : baseLayout.sidebarWidth,
    marginLeft: 0,
  }),
}))

export default Main
